import(/* webpackMode: "eager", webpackExports: ["default"] */ "/vercel/path0/app/degree-planning/Workspace.tsx");
